module.exports = __webpack_public_path__ + "img/logo-betradar.9583d85b.png";